import React, { FC } from "react";

import { FooterStyle } from "./styles";
import banner_arpt from "../../assets/banner_arpt.png";
import { Box } from "@mui/material";

const Footer: FC = () => {
    
    return (
        <Box sx={FooterStyle.footer}>
            <img style={FooterStyle.footerImage} src={banner_arpt} alt="Banner dos apoiadores" />
        </Box>
    );
};

export default Footer;